import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export const HeadingContainer: React.FC = () => {
	const {
		data: { petition: details },
	} = usePetitionDetailsPageData();
	return (
		<div className="py-6">
			<div>
				<Text
					as="h1"
					variant="heading"
					fontWeight="bold"
					data-qa="petition-title"
					className="text-left text-[40px] leading-[52px] break-words lg:text-[48px] lg:leading-[56px]"
				>
					{details.ask}
				</Text>
			</div>
		</div>
	);
};
